import React, {Component} from 'react';
import AUX from '../../hoc/Aux_';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from 'react-router-dom';
import { withRouter, Redirect } from "react-router";

class Crud extends Component{

  constructor(props) {
    super(props);
    this.state = {
      featureCatalog : null
    }
  }

  componentWillMount(){
    if(localStorage.getItem('token')==null){

      console.log(localStorage.getItem('token'));
      this.props.history.push(`/login`);
    }
  }



  render(){
    return (
      <AUX>


      <section className="sections" style = {{paddingTop:"5%"}}>

        <div className="container">
        <Breadcrumbs aria-label="breadcrumb">

        </Breadcrumbs>
          <div className="row justify-content-center" >

            <h4 >HALAMAN ADMINISTRATOR</h4>
            <p>Halaman ini merupakan halaman awal bagi administrator untuk melakukan penyuntingan pada berbagai informasi yang terdapat dalam Katalog Unsur Geografi Indonesia. Admin dapat menyunting, menambah dan menghapus nama kategori, unsur, atribut hingga isian domain. setiap hasil update yang sudah disimpan selama sesi edit katalog maupun edit unsur memerlukan generate RDF agar hasil tersebut dapat tampil pada web KUGI.</p>

          <br/>

          <br/>
          <br/>

          </div>
        </div>
      </section>
      <br/>
      </AUX>
    )
  }
}

export default withRouter(Crud);
